import { useEffect, useState } from 'react';

/**
 * Diz se a viewport está abaixo do breakpoint `sm` do Tailwind (640px) — a
 * faixa do celular. Usado pelos relatórios para decisões que CSS sozinho não
 * resolve (intervalo do eixo X, legenda dos gráficos, largura de eixo de
 * categorias, altura do mapa).
 *
 * Seguro sem `window`/`matchMedia` (SSR, jsdom antigo): devolve false.
 */
export function useIsMobile(query = '(max-width: 639px)'): boolean {
  const getMatch = (): boolean => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return window.matchMedia(query).matches;
  };

  const [isMobile, setIsMobile] = useState<boolean>(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}

export default useIsMobile;
